import React from "react";
import { SearchBar } from "@c4c-web/ui";
import { cn } from "@c4c-web/libs-hooks/libs";
import type { TranslationFn } from "../../../types";

interface IMapSearchBarProps {
  isAddressSelected: boolean;
  onChangeHandler: () => void;
  searchBarRef: React.RefObject<HTMLInputElement>;
  t: TranslationFn;
}

export const MapSearchBar: React.FC<IMapSearchBarProps> = ({
  isAddressSelected,
  onChangeHandler,
  searchBarRef,
  t,
}) => {
  return (
    <div
      className={cn(
        "absolute ltr:left-1/2 rtl:right-1/2 top-[85px] z-10 w-11/12 ltr:-translate-x-1/2 rtl:translate-x-1/2 md:top-[90px]",
        { "w-4/5": isAddressSelected },
      )}
    >
      <SearchBar
        clearButtonLabel="clear"
        id="pac-input-add-address"
        onChange={onChangeHandler}
        placeholder={t("addressJourney.searchForAnAreaStreetOrBuilding")}
        ref={searchBarRef}
        value={searchBarRef.current?.value}
        variant="address"
      />
    </div>
  );
};
